import { RecipientType } from '../../api/model/common/RecipientType';
import integrations from '../utils/integrations';
import RecipientSelector from './RecipientSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const COMMON_I18N_KEYS = {
  labelKey: 'shareWithThirdPartyComponentLibrary.channelSelector.label',
  placeholderKey: 'shareWithThirdPartyComponentLibrary.channelSelector.placeholder',
  alertTitleTranslationKey: 'shareWithThirdPartyComponentLibrary.channelSelector.fetchingError.title'
};
const GOOGLE_CHAT_I18N_KEYS = {
  labelKey: 'shareWithThirdPartyComponentLibrary.chatSpaceSelector.label',
  placeholderKey: 'shareWithThirdPartyComponentLibrary.chatSpaceSelector.placeholder',
  alertTitleTranslationKey: 'shareWithThirdPartyComponentLibrary.chatSpaceSelector.fetchingError.title'
};
const ChannelSelector = ({
  onChange,
  appId,
  defaultValue,
  disabled,
  clearable
}) => {
  const i18nKeys = integrations.isGoogleChatAppId(appId) ? GOOGLE_CHAT_I18N_KEYS : COMMON_I18N_KEYS;
  return /*#__PURE__*/_jsx(RecipientSelector, {
    onChange: onChange,
    appId: appId,
    recipientType: RecipientType.CHANNEL,
    selectorAppearanceConfig: Object.assign({}, i18nKeys, {
      clearable: clearable !== undefined ? clearable : false
    }),
    defaultValue: defaultValue,
    disabled: disabled
  });
};
export default ChannelSelector;